import {
  Button,
  Card,
  ListItem,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TablePagination,
  useTheme,
  TableSortLabel,
  IconButton,
  makeStyles,
  lighten,
  Paper,
  TextField,
  withStyles,
} from "@material-ui/core";
import React, { useState, useEffect, useContext, useMemo } from "react";
import OwnerHeader from "../Components/OwnerHeader";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import { useHistory, useParams } from "react-router-dom";
import { Instance } from "../../../Config";
import CustomSnakBar from "../../../Components/CustomSnakBar";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { CSVLink } from "react-csv";
import GlobalContext from "../../../Context/globalContext";

import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import FilterListIcon from "@material-ui/icons/FilterList";
import { SHOW_SNACKBAR } from "../../../Context/globalActions.types";
import { Skeleton, Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  fullWidth: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: "#FBFBFB",
    },
    "&:hover": {
      backgroundColor: "#F3F3F3",
      transform: "scale(1.0019)",
    },
  },
}))(TableRow);

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export default function OrderSizeWiseReport() {
  const classes = useStyles();
  const { globalContext, dispatch } = useContext(GlobalContext);
  const [fromDate, setFromDate] = useState(
    moment().subtract(1, "year").format("YYYY-MM-DD hh:mm:ss"),
  );
  const [toDate, setToDate] = useState(
    moment().subtract(1, "days").format("YYYY-MM-DD hh:mm:ss"),
  );
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("ORDER_NO");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [rows, setRows] = useState([]);
  const [processedData, setProcessedData] = useState([]);
  const params = useParams();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const [totalQty, setTotalQty] = useState(0);
  const [totalPcs, setTotalPcs] = useState(0);
  const [availableSizes, setAvailableSizes] = useState([]);

  const [showFilters, setShowFilters] = useState(false);

  // Filter states
  const [selectedParty, setSelectedParty] = useState(null);
  const [selectedDistributor, setSelectedDistributor] = useState(null);
  const [selectedDept, setSelectedDept] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [parties, setParties] = useState([]);
  const [distributors, setDistributors] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [items, setItems] = useState([]);
  const [statusOptions] = useState(["Pending", "Dispatched", "Canceled"]);

  // Process data to group by order and item, then aggregate by size
  const processOrderData = (orders) => {
    const orderItemMap = [];

    // Process each order separately to maintain order details
    orders.forEach((order) => {
      const itemMap = new Map();

      order.orderItm?.forEach((item) => {
        const key = item.ITEM_CD;

        if (!itemMap.has(key)) {
          // Get DESC1 from the nested structure (item.item.variant[0].DESC1)
          const variantMatch = item.item?.variant?.find(
            (v) => v.SIZE_CD === item.SIZE_CD,
          );
          const packingPcs = variantMatch?.DESC1
            ? parseInt(variantMatch.DESC1)
            : 1;

          itemMap.set(key, {
            orderId: order.orderId,
            ORDER_NO: order.ORDER_NO,
            PARTY_NAME: order.accounts?.ACC_NAME || "",
            PARTY_CD: order.PARTY_CD,
            DISTRIBUTOR: order.accounts?.distributor?.ACC_NAME || "",
            DISTRIBUTOR_CD: order.accounts?.OTHER_ID || "",
            SMAN_NAME: order.sman?.SMAN_NAME || "",
            SMAN_CD: order.SMAN_CD || "",
            ITEM_CD: item.ITEM_CD,
            ITEM_NAME: item.ITEM_NAME,
            DEPT_CD: item.DEPT_CD,
            DESC1: packingPcs, // Packing PCS
            REMARKS1: item.REMARKS1 || "",
            STATUS: item.ISTATUS || "",
            createdAt: order.createdAt || "",
            sizes: {},
            totalQty: 0,
          });
        }

        const itemData = itemMap.get(key);
        const size = item.SIZE_CD || "N/A";

        // Aggregate quantities by size
        if (!itemData.sizes[size]) {
          itemData.sizes[size] = 0;
        }
        itemData.sizes[size] += item.QUANTITY || 0;
        itemData.totalQty += item.QUANTITY || 0;
      });

      // Add all items from this order
      Array.from(itemMap.values()).forEach((item) => {
        orderItemMap.push({
          ...item,
          totalPcs: item.totalQty * item.DESC1,
        });
      });
    });

    // Get all unique sizes
    const sizeSet = new Set();
    orderItemMap.forEach((item) => {
      Object.keys(item.sizes).forEach((size) => sizeSet.add(size));
    });

    // Sort sizes in standard order
    const standardSizes = [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
    ];
    const sortedSizes = Array.from(sizeSet).sort((a, b) => {
      const indexA = standardSizes.indexOf(a);
      const indexB = standardSizes.indexOf(b);

      if (indexA !== -1 && indexB !== -1) return indexA - indexB;
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;
      return a.localeCompare(b);
    });

    setAvailableSizes(sortedSizes);
    setProcessedData(orderItemMap);

    // Calculate totals
    const totalQ = orderItemMap.reduce((acc, item) => acc + item.totalQty, 0);
    const totalP = orderItemMap.reduce((acc, item) => acc + item.totalPcs, 0);
    setTotalQty(totalQ);
    setTotalPcs(totalP);
  };

  const fetchData = () => {
    setIsLoading(true);
    Instance.get(
      `/reports/orders?mobileNo=${params.mobileNo}&fromDate=${fromDate}&toDate=${toDate}`,
    )
      .then((res) => {
        if (res) {
          setIsLoading(false);
          setRows(res.data.result);
          processOrderData(res.data.result);

          // Extract unique parties, distributors, departments, and items for filters
          const partyMap = new Map();
          const distributorMap = new Map();
          const deptSet = new Set();
          const itemMap = new Map();

          res.data.result.forEach((order) => {
            // Add party
            if (order.accounts?.ACC_NAME && order.PARTY_CD) {
              partyMap.set(order.PARTY_CD, {
                PARTY_CD: order.PARTY_CD,
                ACC_NAME: order.accounts.ACC_NAME,
              });
            }

            // Add distributor
            if (
              order.accounts?.distributor?.ACC_NAME &&
              order.accounts?.OTHER_ID
            ) {
              distributorMap.set(order.accounts.OTHER_ID, {
                DISTRIBUTOR_CD: order.accounts.OTHER_ID,
                ACC_NAME: order.accounts.distributor.ACC_NAME,
              });
            }

            // Add items and departments
            order.orderItm?.forEach((item) => {
              if (item.ITEM_CD && !itemMap.has(item.ITEM_CD)) {
                itemMap.set(item.ITEM_CD, {
                  ITEM_CD: item.ITEM_CD,
                  ITEM_NAME: item.ITEM_NAME,
                });
              }
              if (item.DEPT_CD) {
                deptSet.add(item.DEPT_CD);
              }
            });
          });

          setParties(
            Array.from(partyMap.values()).sort((a, b) =>
              a.ACC_NAME.localeCompare(b.ACC_NAME),
            ),
          );
          setDistributors(
            Array.from(distributorMap.values()).sort((a, b) =>
              a.ACC_NAME.localeCompare(b.ACC_NAME),
            ),
          );
          setDepartments(Array.from(deptSet).sort());
          setItems(
            Array.from(itemMap.values()).sort((a, b) =>
              a.ITEM_NAME.localeCompare(b.ITEM_NAME),
            ),
          );
        }
      })
      .catch(() => {
        setIsLoading(false);
        dispatch({
          type: SHOW_SNACKBAR,
          payload: {
            message: "Something went wrong",
            type: "error",
          },
        });
      });
  };

  const handleFromDateChange = (date) => {
    setFromDate(moment(date).format("YYYY-MM-DD hh:mm:ss"));
  };

  const handleToDateChange = (date) => {
    setToDate(moment(date).format("YYYY-MM-DD hh:mm:ss"));
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  // Filter data based on selected filters
  const getFilteredData = () => {
    let filtered = processedData;

    if (selectedParty) {
      filtered = filtered.filter(
        (row) => row.PARTY_CD === selectedParty.PARTY_CD,
      );
    }
    if (selectedDistributor) {
      filtered = filtered.filter(
        (row) => row.DISTRIBUTOR_CD === selectedDistributor.DISTRIBUTOR_CD,
      );
    }
    if (selectedDept) {
      filtered = filtered.filter((row) => row.DEPT_CD === selectedDept);
    }
    if (selectedItem) {
      filtered = filtered.filter((row) => row.ITEM_CD === selectedItem.ITEM_CD);
    }
    if (selectedStatus) {
      filtered = filtered.filter((row) => row.STATUS === selectedStatus);
    }

    return filtered;
  };

  const filteredData = getFilteredData();

  // Get current page data
  const currentPageData = useMemo(() => {
    return stableSort(filteredData, getComparator(order, orderBy)).slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage,
    );
  }, [filteredData, order, orderBy, page, rowsPerPage]);

  // Calculate visible sizes based on current page data only
  const visibleSizes = useMemo(() => {
    const standardSizes = [
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "2XL",
      "3XL",
      "4XL",
      "5XL",
    ];

    const sizesWithValues = new Set();
    currentPageData.forEach((row) => {
      if (row.sizes && typeof row.sizes === "object") {
        Object.entries(row.sizes).forEach(([size, quantity]) => {
          const qty = Number(quantity);
          if (!isNaN(qty) && qty > 0) {
            sizesWithValues.add(size);
          }
        });
      }
    });

    return Array.from(sizesWithValues).sort((a, b) => {
      const indexA = standardSizes.indexOf(a);
      const indexB = standardSizes.indexOf(b);
      if (indexA !== -1 && indexB !== -1) return indexA - indexB;
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;
      const numA = parseInt(a, 10);
      const numB = parseInt(b, 10);
      if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
      return a.localeCompare(b);
    });
  }, [currentPageData]);

  const headCells = useMemo(
    () => [
      { id: "ORDER_NO", label: "Order No" },
      { id: "PARTY_NAME", label: "Party" },
      { id: "DISTRIBUTOR", label: "Distributor" },
      { id: "SMAN_NAME", label: "Salesman" },
      { id: "ITEM_CD", label: "Item Cd" },
      { id: "ITEM_NAME", label: "Item" },
      { id: "DEPT_CD", label: "Dept" },
      { id: "DESC1", label: "Packing PCS" },
      ...visibleSizes.map((size) => ({
        id: `size_${size}`,
        label: size,
      })),
      { id: "totalQty", label: "Qty" },
      { id: "totalPcs", label: "Total PCS" },
      { id: "STATUS", label: "Status" },
      { id: "createdAt", label: "Date" },
    ],
    [visibleSizes],
  );

  // Prepare CSV headers with dynamic size columns
  const headers = [
    { label: "Order No", key: "ORDER_NO" },
    { label: "Party", key: "PARTY_NAME" },
    { label: "Distributor", key: "DISTRIBUTOR" },
    { label: "Salesman", key: "SMAN_NAME" },
    { label: "Item Cd", key: "ITEM_CD" },
    { label: "Item", key: "ITEM_NAME" },
    { label: "Dept", key: "DEPT_CD" },
    { label: "Packing PCS", key: "DESC1" },
    ...availableSizes.map((size) => ({ label: size, key: size })),
    { label: "Qty", key: "totalQty" },
    { label: "Total PCS", key: "totalPcs" },
    { label: "Status", key: "STATUS" },
    { label: "Date", key: "createdAt" },
  ];

  const exportPdf = () => {
    const unit = "pt";
    const size = "A4";
    const orientation = "landscape";

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = "Order Wise Size Wise Report";
    const headerRow = [
      "Order No",
      "Party",
      "Distributor",
      "Salesman",
      "Item Cd",
      "Item",
      "Dept",
      "Packing PCS",
      ...availableSizes,
      "Qty",
      "Total PCS",
      "Status",
      "Date",
    ];

    const data = filteredData.map((item) => [
      item.ORDER_NO,
      item.PARTY_NAME,
      item.DISTRIBUTOR,
      item.SMAN_NAME,
      item.ITEM_CD,
      item.ITEM_NAME,
      item.DEPT_CD,
      item.DESC1,
      ...availableSizes.map((size) => item.sizes[size] || ""),
      item.totalQty,
      item.totalPcs,
      item.STATUS,
      moment(item.createdAt).format("DD-MM-YYYY"),
    ]);

    // Add totals row
    const totalsRow = [
      "Total",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      ...availableSizes.map(() => ""),
      totalQty,
      totalPcs,
      "",
      "",
    ];
    data.push(totalsRow);

    let content = {
      startY: 70,
      head: [headerRow],
      body: data,
      styles: { fontSize: 8 },
      headStyles: { fontSize: 9, fontStyle: "bold" },
    };

    let width1 = doc.internal.pageSize.getWidth();

    doc.setFontSize(14).setFont(undefined, "bold");
    doc
      .text(globalContext.company[0].COMP_NAME, width1 / 2, 20, {
        align: "center",
      })
      .setFontSize(8)
      .setFont(undefined, "bold");
    doc.text(globalContext.company[0].ADDRS, width1 / 2, 38, {
      align: "center",
    });
    doc.text(
      `From Date: ${moment(fromDate).format("DD-MM-YYYY")} To: ${moment(
        toDate,
      ).format("DD-MM-YYYY")}`,
      width1 / 2,
      60,
      {
        align: "center",
      },
    );
    doc.autoTable(content);
    doc.save("OrderSizeWiseReport.pdf");
  };

  function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;

    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead className="sticky top-0">
        <TableRow className="md:mx-3 md:bg-white bg-gray-200">
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align="left"
              className="font-bold border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-5 w-max bg-transparent"
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    return (
      <div className={classes.root}>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
      </div>
    );
  }

  // Calculate totals based on ALL records (processedData), not just filtered
  useEffect(() => {
    const totalQ = processedData.reduce((acc, item) => acc + item.totalQty, 0);
    const totalP = processedData.reduce((acc, item) => acc + item.totalPcs, 0);
    setTotalQty(totalQ);
    setTotalPcs(totalP);
  }, [processedData]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <OwnerHeader>
      <div className="md:flex items-center justify-between px-3 md:px-4 py-3">
        <div>
          <div className="text-indigo-500 font-semibold text-sm md:text-base">
            Reporting
          </div>
          <div className="text-xl md:text-2xl font-extrabold leading-7 sm:leading-10 truncate mt-1">
            Order Wise Size Wise Report
          </div>
        </div>
      </div>
      <div className="py-1 min-h-screen bg-[#F1F5F9] px-2">
        <Card className="mb-4 shadow-sm">
          <ListItem className="pb-0">
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center">
                <FilterListIcon className="text-indigo-500" />
                <Typography
                  variant="h6"
                  className="text-indigo-500 uppercase font-bold tracking-wider text-xs ml-2"
                >
                  Advanced Filters
                </Typography>
              </div>
              <Button size="small" onClick={() => setShowFilters(!showFilters)}>
                {showFilters ? "Hide" : "Show"}
              </Button>
            </div>
          </ListItem>
          {showFilters && (
            <div className="px-4 pb-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-3">
                {window.innerWidth < 600 ? (
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="From"
                    format="DD/MM/yyyy"
                    value={fromDate}
                    onChange={handleFromDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    className="bg-white"
                  />
                ) : (
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="DD/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="From"
                    value={fromDate}
                    onChange={handleFromDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    className="bg-white"
                  />
                )}
                {window.innerWidth < 600 ? (
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="To"
                    format="DD/MM/yyyy"
                    value={toDate}
                    onChange={handleToDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    className="bg-white"
                  />
                ) : (
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="DD/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="To"
                    value={toDate}
                    onChange={handleToDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    className="bg-white"
                  />
                )}

                <Autocomplete
                  id="party-filter"
                  autoHighlight
                  options={parties}
                  getOptionLabel={(option) => option.ACC_NAME}
                  value={selectedParty}
                  renderOption={(option) => (
                    <React.Fragment>{option.ACC_NAME}</React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      label="Party"
                      margin="normal"
                      className="bg-white"
                    />
                  )}
                  onChange={(_e, value) => {
                    setSelectedParty(value);
                  }}
                />

                <Autocomplete
                  id="distributor-filter"
                  autoHighlight
                  options={distributors}
                  getOptionLabel={(option) => option.ACC_NAME}
                  value={selectedDistributor}
                  renderOption={(option) => (
                    <React.Fragment>{option.ACC_NAME}</React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      label="Distributor"
                      margin="normal"
                      className="bg-white"
                    />
                  )}
                  onChange={(_e, value) => {
                    setSelectedDistributor(value);
                  }}
                />

                <Autocomplete
                  id="department-filter"
                  autoHighlight
                  options={departments}
                  getOptionLabel={(option) => option}
                  value={selectedDept}
                  renderOption={(option) => (
                    <React.Fragment>{option}</React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      label="Department"
                      margin="normal"
                      className="bg-white"
                    />
                  )}
                  onChange={(_e, value) => {
                    setSelectedDept(value);
                  }}
                />

                <Autocomplete
                  id="item-filter"
                  autoHighlight
                  options={items}
                  getOptionLabel={(option) => option.ITEM_NAME}
                  value={selectedItem}
                  renderOption={(option) => (
                    <React.Fragment>{option.ITEM_NAME}</React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      label="Item"
                      margin="normal"
                      className="bg-white"
                    />
                  )}
                  onChange={(_e, value) => {
                    setSelectedItem(value);
                  }}
                />

                <Autocomplete
                  id="status-filter"
                  autoHighlight
                  options={statusOptions}
                  getOptionLabel={(option) => option}
                  value={selectedStatus}
                  renderOption={(option) => (
                    <React.Fragment>{option}</React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      label="Status"
                      margin="normal"
                      className="bg-white"
                    />
                  )}
                  onChange={(_e, value) => {
                    setSelectedStatus(value);
                  }}
                />
              </div>
              <div className="flex justify-end gap-2">
                <Button
                  variant="contained"
                  disableElevation
                  className="bg-[#3333cc] text-white"
                  onClick={fetchData}
                >
                  Apply Filters
                </Button>
                {(selectedParty ||
                  selectedDistributor ||
                  selectedDept ||
                  selectedItem ||
                  selectedStatus) && (
                  <Button
                    variant="outlined"
                    disableElevation
                    onClick={() => {
                      setSelectedParty(null);
                      setSelectedDistributor(null);
                      setSelectedDept(null);
                      setSelectedItem(null);
                      setSelectedStatus(null);
                    }}
                  >
                    Clear Filters
                  </Button>
                )}
              </div>
            </div>
          )}
        </Card>
        <React.Fragment>
          <Paper>
            <div className="md:flex justify-between w-full mt-3 mb-2 px-4 pt-3">
              <Typography className="text-md md:text-lg mb-2 font-medium">
                Order Wise Size Wise Report
              </Typography>
              <div className="flex gap-2">
                <Button
                  variant="outlined"
                  className="text-blue-600 border-[#3333cc]"
                  startIcon={<SaveAltIcon />}
                  size="small"
                >
                  <CSVLink
                    data={filteredData.map((item) => {
                      // Create an object with size columns flattened
                      const flattenedItem = {
                        ORDER_NO: item.ORDER_NO,
                        PARTY_NAME: item.PARTY_NAME,
                        DISTRIBUTOR: item.DISTRIBUTOR,
                        SMAN_NAME: item.SMAN_NAME,
                        ITEM_CD: item.ITEM_CD,
                        ITEM_NAME: item.ITEM_NAME,
                        DEPT_CD: item.DEPT_CD,
                        DESC1: item.DESC1,
                        totalQty: item.totalQty,
                        totalPcs: item.totalPcs,
                        STATUS: item.STATUS,
                        createdAt: moment(item.createdAt).format("DD-MM-YYYY"),
                      };
                      // Add each size as a separate column
                      availableSizes.forEach((size) => {
                        flattenedItem[size] = item.sizes[size] || "";
                      });
                      return flattenedItem;
                    })}
                    headers={headers}
                    filename="OrderSizeWiseReport.csv"
                    className="text-blue-600"
                  >
                    Excel
                  </CSVLink>
                </Button>
                <Button
                  variant="outlined"
                  className="text-blue-600 border-[#3333cc]"
                  startIcon={<InsertDriveFileOutlinedIcon />}
                  onClick={exportPdf}
                  size="small"
                >
                  PDF
                </Button>
              </div>
            </div>

            <div className="max-h-screen overflow-x-hidden">
              <Table stickyHeader>
                <EnhancedTableHead
                  classes={classes}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                  rowCount={filteredData ? filteredData.length : 0}
                />
                <TableBody>
                  {isLoading && processedData.length === 0 ? (
                    <StyledTableRow>
                      {headCells.map((_cell, index) => (
                        <StyledTableCell
                          key={index}
                          className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                        >
                          <Skeleton />
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  ) : !isLoading && filteredData.length === 0 ? (
                    <TableRow hover tabIndex={-1}>
                      <TableCell align="center" colSpan={headCells.length}>
                        No Data Found
                      </TableCell>
                    </TableRow>
                  ) : (
                    stableSort(filteredData, getComparator(order, orderBy))
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      .map((row) => {
                        return (
                          <StyledTableRow
                            key={`${row.orderId}-${row.ITEM_CD}`}
                            className="hover:font-semibold cursor-pointer"
                            onClick={() => {
                              history.push(
                                `/${params.mobileNo}/owner/orderdetail?id=${row.orderId}`,
                              );
                            }}
                          >
                            <StyledTableCell
                              align="left"
                              style={{ fontWeight: "inherit" }}
                              className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                            >
                              {row.ORDER_NO}
                            </StyledTableCell>
                            <StyledTableCell
                              align="left"
                              style={{ fontWeight: "inherit" }}
                              className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                            >
                              {row.PARTY_NAME}
                            </StyledTableCell>
                            <StyledTableCell
                              align="left"
                              style={{ fontWeight: "inherit" }}
                              className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                            >
                              {row.DISTRIBUTOR}
                            </StyledTableCell>
                            <StyledTableCell
                              align="left"
                              style={{ fontWeight: "inherit" }}
                              className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                            >
                              {row.SMAN_NAME}
                            </StyledTableCell>
                            <StyledTableCell
                              align="left"
                              style={{ fontWeight: "inherit" }}
                              className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                            >
                              {row.ITEM_CD}
                            </StyledTableCell>
                            <StyledTableCell
                              align="left"
                              style={{ fontWeight: "inherit" }}
                              className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                            >
                              {row.ITEM_NAME}
                            </StyledTableCell>
                            <StyledTableCell
                              align="left"
                              style={{ fontWeight: "inherit" }}
                              className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                            >
                              {row.DEPT_CD}
                            </StyledTableCell>
                            <StyledTableCell
                              align="left"
                              style={{ fontWeight: "inherit" }}
                              className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                            >
                              {row.DESC1}
                            </StyledTableCell>
                            {visibleSizes.map((size) => (
                              <StyledTableCell
                                key={size}
                                align="left"
                                style={{ fontWeight: "inherit" }}
                                className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                              >
                                {row.sizes[size] || ""}
                              </StyledTableCell>
                            ))}
                            <StyledTableCell
                              align="left"
                              style={{ fontWeight: "inherit" }}
                              className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                            >
                              {parseFloat(row.totalQty).toFixed(2)}
                            </StyledTableCell>
                            <StyledTableCell
                              align="left"
                              style={{ fontWeight: "inherit" }}
                              className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                            >
                              {parseFloat(row.totalPcs).toFixed(2)}
                            </StyledTableCell>
                            <StyledTableCell
                              align="left"
                              style={{ fontWeight: "inherit" }}
                              className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                            >
                              <span
                                className={
                                  row.STATUS === "Pending"
                                    ? "rounded-md px-2 py-1 bg-[#ff6600] text-white"
                                    : row.STATUS === "Dispatched"
                                      ? "rounded-md px-2 py-1 bg-[#049aab] text-white"
                                      : row.STATUS === "Canceled"
                                        ? "rounded-md px-2 py-1 bg-[#3333cc] text-white"
                                        : row.STATUS === "Approved"
                                          ? "rounded-md px-2 py-1 bg-green-400 text-white"
                                          : "rounded-md px-2 py-1 bg-[#009999] text-white"
                                }
                              >
                                {row.STATUS || "-"}
                              </span>
                            </StyledTableCell>
                            <StyledTableCell
                              align="left"
                              style={{ fontWeight: "inherit" }}
                              className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4"
                            >
                              {moment(row.createdAt).format("DD-MM-YYYY")}
                            </StyledTableCell>
                          </StyledTableRow>
                        );
                      })
                  )}
                </TableBody>
              </Table>
            </div>

            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              component="div"
              count={filteredData ? filteredData.length : 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />

            {processedData.length > 0 && (
              <div className="px-4 py-3 bg-gray-50 border-t border-gray-200">
                <div className="flex justify-between items-center">
                  <div className="text-sm font-semibold text-gray-700">
                    Total Qty:{" "}
                    <span className="text-blue-600">
                      {parseFloat(totalQty).toFixed(2)}
                    </span>
                  </div>
                  <div className="text-sm font-semibold text-gray-700">
                    Total PCS:{" "}
                    <span className="text-blue-700">
                      {parseFloat(totalPcs).toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </Paper>
        </React.Fragment>
      </div>
    </OwnerHeader>
  );
}
